import { useCallback, useEffect, useState } from "react";
import { obtenerConfiguracionTiendaPublic } from "../../../services/public/configuracionTienda";
import { formatearPrecio } from "../../../utils/moneda";

export function useConfiguracionTiendaPublic() {
  const [configuracionTienda, setConfiguracionTienda] = useState(null);

  useEffect(() => {
    let alive = true;
    obtenerConfiguracionTiendaPublic().then((cfg) => {
      if (alive && cfg) setConfiguracionTienda(cfg);
    });
    return () => {
      alive = false;
    };
  }, []);

  const formatMoney = useCallback(
    (value) =>
      formatearPrecio(value, configuracionTienda, {
        espacioEntreSimbolo: true,
      }) || "—",
    [configuracionTienda]
  );

  return { configuracionTienda, formatMoney };
}
